<template>
    <div class="community-activity-meth">
        <ATable :fields="fields" :data="items">
            <template #col-meth_amount="{ data }">{{ data }} METH</template>
            <template #col-wallet_address="{ data }">
                <CollectionCommunityActivityWallet :wallet="data" />
            </template>
            <template #col-date="{ data }">
                <CollectionCommunityActivityDate :date="data" />
            </template>
        </ATable>
    </div>
</template>
<script setup>
import ATable from "@/components/ATable/ATable.vue";
import { ref } from "vue";
import CollectionCommunityActivityDate from "./CollectionCommunityActivityDate.vue";
import CollectionCommunityActivityWallet from "./CollectionCommunityActivityWallet.vue";
const props = defineProps({ items: { type: Array, default: () => [] } })
const fields = [
    {
        name: "Date",
        value: "date"
    },
    {
        name: "Wallet",
        value: "wallet_address"
    },
    {
        name: "Type",
        value: "reward_type_pretty"
    },
]
</script>
<style lang="scss"></style>